;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('MM/Models/Search/SimpleSearchClient',['jquery', 'errorHandler', 'score_bootstrap/Models/Search/SearchRequest'], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("errorHandler"), require('score_bootstrap/Models/Search/SearchRequest')) :
  console && console.error('SimpleSearchClient does not support non-amd script loading.');
}(this/* window */, function ($, errorHandler, SearchRequest) {
    function SimpleSearchClient(searchUrl, perPage, language, root, indexName, templates, startPage, page, tileNames, component) {

        var searchRequest = new SearchRequest();

        if (perPage !== undefined) searchRequest.perPage = perPage;
        if (language) searchRequest.language = language;
        if (root !== undefined) searchRequest.root = root;
        if (indexName !== undefined) searchRequest.indexName = indexName;
        if (templates !== undefined) searchRequest.templates = templates;
        if (page !== undefined) searchRequest.page = page;
        if (startPage !== undefined) searchRequest.startPage = startPage;
        if (component !== undefined) searchRequest.component = component;

        // we can accept a single string or an array or strings
        if (tileNames) {
            typeof (tileNames) === "string"
                ? searchRequest.addTileRequest(tileNames)
                : tileNames.forEach(searchRequest.addTileRequest);
        }

        Object.defineProperties(this, {
            searchRequest: { value: searchRequest },
            searchUrl: { value: searchUrl },
            _lastRequest: { value: void 0, configurable: !0, enumerable: !1, writable: !0 }
        });
    }



    SimpleSearchClient.prototype.search = function search() {
        if (this._lastRequest) {
            this._lastRequest.abort();
        }
        
        var jqXHR = $.ajax({
            url: this.searchUrl,
            data: JSON.stringify(this.searchRequest),
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json"
        });

        //jqXHR.fail(errorHandler.logError);

        this._lastRequest = jqXHR;
        return jqXHR;
    }

    return SimpleSearchClient;
}));
